<template>
  <autocomplete v-model="searchQuery" :options="options" :on-item-selected="onSearchItemSelected" :on-input-change="onInputChange" :required="required">
    <template #item="props">
      <strong>{{ props.item.external_id }}</strong>
      ({{ props.item.reference }})
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  name: 'CommodityAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    preQuery: {
      type: String,
      default: null
    },
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    restrictToRoles: {
      type: Array,
      default: () => []
    },
    includes: {
      type: Array,
      default: () => ['commodity_varieties']
    }
  },
  watch: {
    preQuery(val) {
      this.searchQuery = val || ''
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      },
      currentMssgClass: 'left',
      profilePictureSize: '50'
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Type to search...')
    }
  },
  methods: {
    onInputChange(query) {
      let params = {
        includes: this.includes,
        sort: [
          {
            key: 'external_id',
            direction: 'asc'
          },
          {
            key: 'id',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            or: true,
            filters: [
              ['external_id', 'ct', query.trim()],
              ['reference', 'ct', query.trim()]
            ]
          }
        ]
      }

      if (query.trim().length >= this.minCharacter) {
        return new Promise(resolve => {
          this.$http.get(this.$appConfig.api.baseUrl + 'commodities', {params: params})
            .then(response => {
              resolve(response.body.data)
            })
        })
      }
    },
    onSearchItemSelected(item) {
      this.searchQuery = item.external_id || item.reference
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
